/**
 * Captura best-effort de la geolocalización del navegador para adjuntarla a la
 * compra (trazabilidad del lugar donde se compró). Nunca lanza ni bloquea el
 * checkout: si el usuario niega el permiso, el navegador no soporta geolocation,
 * o hay timeout, resuelve `null` y la compra sigue igual.
 *
 * El navegador pide consentimiento al usuario (permiso de ubicación), que es el
 * mecanismo de consentimiento requerido por habeas data (Ley 1581).
 */
export function getPurchaseLocation({ timeoutMs = 8000 } = {}) {
  return new Promise((resolve) => {
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      resolve(null);
      return;
    }
    let settled = false;
    const done = (value) => {
      if (!settled) {
        settled = true;
        resolve(value);
      }
    };
    // Respaldo por si el navegador nunca invoca los callbacks.
    const timer = setTimeout(() => done(null), timeoutMs + 1000);

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        clearTimeout(timer);
        const c = pos.coords || {};
        if (typeof c.latitude !== "number" || typeof c.longitude !== "number") {
          done(null);
          return;
        }
        done({
          latitude: c.latitude,
          longitude: c.longitude,
          location_accuracy:
            typeof c.accuracy === "number" ? c.accuracy : undefined,
          location_source: "gps",
        });
      },
      () => {
        clearTimeout(timer);
        done(null); // permiso denegado / error: seguir sin ubicación
      },
      { enableHighAccuracy: false, timeout: timeoutMs, maximumAge: 60000 }
    );
  });
}
